module.exports = __webpack_public_path__ + "img/link05.609c3939.png";